// removed by extract-text-webpack-plugin
module.exports = {"button":"_2i4qIVduHPxT4Rik0VLw7l"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/scroll-top.css
// module id = 345
// module chunks = 0